export function verifyActiveMenu(data: string) {
  if (!window) return false;

  const actualPage = window.location.pathname;

  return actualPage.includes(data);
}
